// import React, { useEffect, useState } from 'react';
// import { parseExcel } from '../../utils/parseExcel';
// import accountApi from '../../api/accountApi';
// import { useSelector } from 'react-redux';
// import BSheetApi from '../../api/bSheetApi';
// import { toast } from 'react-toastify';

// const Bsheet = () => {
//   const [file, setFile] = useState(null);
//   const [jsonData, setJsonData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccountId, setSelectedAccountId] = useState("");

//   const token = useSelector((state) => state.auth.access_token);

//   useEffect(() => {
//     if (!token) return;

//     accountApi.getAllAccounts(token, 0, 50)
//       .then((res) => {
//         const accList = res?.data?.content || [];
//         setAccounts(accList);
//       })
//       .catch((err) => {
//         console.error("❌ Error fetching accounts:", err);
//       });
//   }, [token]);

// const fetchBalanceSheets = async () => {
//     try {
//       setLoading(true);
//       const response = await BSheetApi.getBalanceSheetsMonthWise(token,"1b5caf22-2758-4a34-897d-be0f92b877c1","2025-01-01","2025-03-31");
//       console.log("response=====>",response)
      
//       setLoading(false);
//     } catch (err) {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBalanceSheets();
//   }, []);
//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     if (!selected) return;
//     setFile(selected);
//     setJsonData(null);
//     setMessage("");
//   };

//   const handleParse = async () => {
//     if (!file) {
//       alert("Please select an Excel file first.");
//       return;
//     }

//     if (!selectedAccountId) {
//       alert("Please select an account first.");
//       return;
//     }

//     try {
//       setLoading(true);
//       setMessage("");
//       const parsed = await parseExcel(file, { companyAddressUntil: "Balance Sheet" });
//       setJsonData(parsed);

//       console.log("Parsed JSON:", parsed);
//       setMessage("Excel parsed successfully. You can now upload.");

//     } catch (err) {
//       console.error(" Error parsing Excel:", err);
//       setMessage(" Error parsing Excel file.");
//     } finally {
//       setLoading(false);
//     }
//   };

// const handleUpload = async () => {
//   if (!jsonData) {
//     return alert("Parse Excel first!");
//   }

//   if (!selectedAccountId) {
//     return alert("Please select an account.");
//   }

//   try {
//     setLoading(true);
//     setMessage("");
//     const payload = {
//       ...jsonData,
//       accountId: selectedAccountId,
//     };

//     console.log("Payload (same as parsed data):", payload);

//     await BSheetApi.createBalanceSheets(payload,selectedAccountId, token);

//     toast.success("Balance Sheet uploaded successfully!");
//   } catch (error) {
//     console.error("Error saving balance sheet:", error);
//     setMessage("Failed to save balance sheet. Check console.");
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
//       <div className="w-full max-w-3xl bg-white shadow-lg rounded-xl p-6">

//         <h2 className="text-2xl font-bold text-center mb-1">📑 Balance Sheet Upload</h2>
//         <p className="text-center text-gray-500 mb-6">
//           Select Account → Upload Excel → Parse → Save
//         </p>

        
//         <div className="mb-4">
//           <label className="block text-sm font-semibold mb-2">Select Account</label>
//           <select
//             value={selectedAccountId}
//             onChange={(e) => setSelectedAccountId(e.target.value)}
//             className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
//           >
//             <option value="">-- Select Account --</option>
//             {accounts.map((acc) => (
//               <option key={acc.id} value={acc.id}>
//                 {acc.accountName || acc.companyName || acc.title || acc.id}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="mb-4">
//           <label className="block text-sm font-semibold mb-2">Select Excel File</label>
//           <input
//             type="file"
//             accept=".xlsx,.xls"
//             onChange={handleFileChange}
//             className="w-full border border-gray-300 rounded-lg p-2"
//           />
//           {file && (
//             <p className="text-sm text-gray-600 mt-1">📁 {file.name}</p>
//           )}
//         </div>

//         <div className="flex gap-3 mb-4">
//           <button
//             onClick={handleParse}
//             disabled={loading || !file || !selectedAccountId}
//             className={`px-4 py-2 rounded-lg text-white font-semibold transition 
//               ${loading || !file || !selectedAccountId
//                 ? "bg-blue-300 cursor-not-allowed"
//                 : "bg-blue-600 hover:bg-blue-700"}`}
//           >
//             {loading ? "Processing..." : "Parse Excel"}
//           </button>

//           {jsonData && (
//             <button
//               onClick={handleUpload}
//               disabled={loading}
//               className={`px-4 py-2 rounded-lg text-white font-semibold transition 
//                 ${loading ? "bg-green-300 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
//             >
//               {loading ? "Uploading..." : "Save to Database"}
//             </button>
//           )}
//         </div>

        
//         {message && (
//           <p className="text-sm font-semibold text-gray-700 mb-4">
//             {message}
//           </p>
//         )}

      
//         {jsonData && (
//           <div className="border border-gray-200 rounded-lg bg-gray-50 p-4">
//             <h4 className="font-semibold mb-2">🔍 Parsed Data Preview</h4>
//             <pre className="text-xs overflow-y-auto max-h-64">
//               {JSON.stringify(jsonData, null, 2)}
//             </pre>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default Bsheet;
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { parseExcel } from "../../utils/parseExcel";
import accountApi from "../../api/accountApi";
import BSheetApi from "../../api/bSheetApi";
import BalanceSheetChart from "./BalanceSheetChart";

const Bsheet = () => {
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);

  const token = useSelector((state) => state.auth.access_token);

  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(today);


  useEffect(() => {
    if (!token) return;

    accountApi.getAllAccounts(token, 0, 50)
      .then((res) => {
        const list = res?.data?.content || [];
        setAccounts(list);
         if (list.length > 0) setSelectedAccountId(list[0].id);
      })
      .catch((err) => console.error("Account fetch error:", err));
  }, [token]);

  const fetchBalanceSheets = useCallback(async () => {
    if (!selectedAccountId || !token) return;

    try {
      setLoading(true);
      const res = await BSheetApi.getBalanceSheetsMonthWise(
        token,
        selectedAccountId,
        startDate,
        endDate
      );

      setReportData(res?.data || res);
    } catch (err) {
      console.error("Error fetching balance sheets:", err);
      // toast.error("Failed to load balance sheet data");
      setReportData(null);
    } finally {
      setLoading(false);
    }
  }, [selectedAccountId, token, startDate, endDate]);

  useEffect(() => {
    fetchBalanceSheets();
  }, [fetchBalanceSheets]);

 
  const handleStartDateChange = (e) => {
    const newStart = e.target.value;

    if (newStart > today) {
      toast.warning("Start date cannot be in the future");
      return;
    }

    setStartDate(newStart);

    if (endDate && endDate < newStart) {
      toast.warning("End date cannot be earlier than start date");
      setEndDate(newStart);
    }
  };

  const handleEndDateChange = (e) => {
    const newEnd = e.target.value;

    if (newEnd < startDate) {
      toast.warning("End date cannot be earlier than start date");
      return;
    }

    setEndDate(newEnd);
  };


  const handleDirectUpload = async () => {
    if (!file) return toast.warning("Please select an Excel file");
    if (!selectedAccountId) return toast.warning("Please select an account");

    try {
      setLoading(true);

      const parsed = await parseExcel(file, {
        companyAddressUntil: "Balance Sheet",
      });

      await BSheetApi.createBalanceSheets(
        { ...parsed, accountId: selectedAccountId },
        selectedAccountId,
        token
      );

      toast.success("Balance Sheet uploaded successfully!");
      handleUploadSuccess();
    } catch (err) {
      console.error("Upload error:", err);
      // toast.error("Upload failed. Please check the file.");
    } finally {
      setLoading(false);
    }
  };

  const handleUploadSuccess = () => {
    setIsModalOpen(false);
    setFile(null);
    fetchBalanceSheets();
  };

  return (
    <div>

      <div className="max-w-7xl mx-auto flex justify-between items-center mb-2">
        <h1 className="text-2xl font-bold text-gray-800">Balance Sheet</h1>
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-primary text-white px-5 py-2 rounded-lg font-medium shadow transition"
        >
          Upload Report
        </button>
      </div>

      <div className="max-w-7xl mx-auto bg-white p-4 rounded-xl shadow-sm border border-gray-200 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-2">

        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Account</label>
          <select
            value={selectedAccountId}
            onChange={(e) => setSelectedAccountId(e.target.value)}
            className="w-full bg-gray-50 rounded-lg text-sm font-semibold px-3 py-2 focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Account</option>
            {accounts.map((a) => (
              <option key={a.id} value={a.id}>
                {a.accountName || a.companyName}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Start Date</label>
          <input
            type="date"
            value={startDate}
            max={today}
            onChange={handleStartDateChange}
            className="w-full bg-gray-50 rounded-lg text-sm px-3 py-2"
          />
        </div>

        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">End Date</label>
          <input
            type="date"
            value={endDate}
            min={startDate}
            max={today}
            onChange={handleEndDateChange}
            className="w-full bg-gray-50 rounded-lg text-sm px-3 py-2"
          />
        </div>
      </div>

      {/* =========================
            CHART AREA
      ========================= */}
      <div className="max-w-7xl mx-auto min-h-[400px]">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-20 space-y-4">
            <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-400 font-medium">Updating data...</p>
          </div>
        ) : reportData ? (
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            <BalanceSheetChart data={reportData} />
          </div>
        ) : (
          <div className="text-center py-20 bg-white rounded-2xl border-2 border-dashed border-gray-100 text-gray-400">
            No data found for the selected criteria.
          </div>
        )}
      </div>

      {/* =========================
            UPLOAD MODAL (SAME AS P&L)
      ========================= */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl w-full max-w-xl shadow-2xl overflow-hidden">
            <div className="px-6 py-1 border-b flex justify-between items-center bg-gray-50">
              <h2 className="text-xl font-bold text-gray-800">New Balance Sheet Upload</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-2xl text-gray-400"
              >
                &times;
              </button>
            </div>

            <div className="p-8 text-center">

              {/* ACCOUNT INSIDE MODAL (IMPORTANT FIX) */}
              <div className="mb-6 text-left">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                  Uploading To Account
                </label>
                <select
                  value={selectedAccountId}
                  onChange={(e) => setSelectedAccountId(e.target.value)}
                  className="w-full bg-gray-50 rounded-lg text-sm font-semibold px-3 py-2 mt-1"
                >
                  <option value="">Select Account</option>
                  {accounts.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.accountName || a.companyName}
                    </option>
                  ))}
                </select>
              </div>

              <input
                type="file"
                id="xl"
                className="hidden"
                accept=".xlsx,.xls"
                onChange={(e) => setFile(e.target.files[0])}
              />

              <label
                htmlFor="xl"
                className="border-2 border-dashed border-gray-200 rounded-2xl p-12 block cursor-pointer hover:border-blue-400 transition mb-6"
              >
                <p className="text-gray-500 font-medium">
                  {file ? `📄 ${file.name}` : "Click to select Excel File"}
                </p>
              </label>

              <button
                onClick={handleDirectUpload}
                disabled={!file || loading}
                className="w-full bg-primary text-white py-3 rounded-xl font-bold disabled:bg-gray-300"
              >
                {loading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bsheet;
